import { getTransactions, GetTransactionsParams } from "@/api/transactions";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { transactionKeys } from "./keys";

export function transactionsQueryOptions(query: GetTransactionsParams) {
	return queryOptions({
		queryKey: transactionKeys.list(query),
		queryFn: () => getTransactions(query),
		refetchOnMount: "always",
	});
}

export const useGetTransactions = (query: GetTransactionsParams) => {
	return useQuery(transactionsQueryOptions(query));
};
